<template>
  <div class="record-card">
    <div class="record-head">
      <div class="record-left">
        <span class="hourglass_empty">
          <v-icon class="hourglass_empty"></v-icon>
          <b>Trade Prepare</b>
        </span>
        <span class="text-grey">
          |
          {{postTime}}
          |
          Status:
          <v-chip
            class="ml-2"
            :color="record.status == 'filled' ? '#79C04D' : record.status == 'expired' ? '#808F9C' : '#E62163'"
            small
          >
          
            <span>
              
              {{record.status}}
            </span>
          </v-chip>
        </span>
        <div class="record-body">
          <div>
            <b>
              <span :class="record.tradeType == 'Long' ? 'up' : 'down'">{{record.tradeType}}</span>
            </b>
            |
            <b>{{record._strategy.name}}</b>
            |
            <b>{{record.symbol.user}}</b>
            | Zone:
            <b>{{record.price}}</b>
          </div>
          <div class="mt-2">
            <v-chip
            small
                v-for="check in record.checklist"
                :key="check._id"
                :color="check.selected ? '#4dbac0' : '' "
                class="float-left mr-2 pointer"
              >
                <v-avatar left>
                  <v-icon size="18" v-if="check.selected">check_box</v-icon>
                  <v-icon size="18" v-else>check_box_outline_blank</v-icon>
                </v-avatar>
                {{check.name}}
              </v-chip>
            
          </div>
        </div>
      </div>
    </div>
    <div class="record-right">
      <v-menu right bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon color="#B6C1CB">more_vert</v-icon>
          </v-btn>
        </template>

        <v-list class="my-vlist" dense>
          <v-list-item v-if="record.status == 'pending'" class="my-vlistitem">
            <v-list-item-title @click="cancelPrep" class="my-vlistitemtitle">
              <v-icon class="menu-icons">cancel</v-icon>Cancel
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="record.status == 'pending'" class="my-vlistitem">
            <v-list-item-title class="my-vlistitemtitle">
              <v-icon class="menu-icons">edit</v-icon>Edit
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </div>
</template>

<script>
var moment = require("moment");
export default {
  name: "PreparationItem",
  props: ["record"],
  data() {
    return {
      remain: null //=> '26 years, 9 months, and 4 days'
    };
  },
  computed: {
    postTime() {
      return moment(this.record.createdAt).fromNow();
    },
    tagsArray() {
      var tagIds = this.record.tags;
      var tagNames = [];
      tagIds.forEach(item => {
        tagNames.push(this.$store.state.userInfo.patterns[item].name);
      });
      return tagNames;
    }
  },
  mounted() {
    // updating record time
    this.updateTiems();
    setInterval(() => {
      this.updateTiems();
    }, 1000);
  },
  methods: {
    cancelPrep() {
      this.$emit("loading", true);
      var apiData = {
        action: "update",
        component: "TradePreparation",
        data: {
          id: this.record._id,
          affected: { key: "Status", value: "canceled" }
        }
      };

      this.$store
        .dispatch("API_COMPONENT_REQUESTS", apiData)
        .then(() => {
          this.$emit("loading", false);
        })
        .catch(() => {
          alert("API failed: Cancel Trade Preparation");
          this.$emit("loading", false);
        });
    },
    updateTiems() {
      var value = this.record.Created;
      this.fromNow = moment.tz(value, this.$store.getters.timezone).fromNow();

      if (this.record.TiF != 9999999999999) {
        let start = moment(); // some random moment in time (in ms)
        let end = moment(this.record.TiF); // some random moment after start (in ms)
        let diff = end.diff(start);

        if (Date.now() > this.record.TiF) this.remain = "expired";
        else this.remain = moment.utc(diff).format("HH:mm:ss");
      } else {
        this.remain = "Until Cancel";
      }
    }
  },
  filters: {
    from: function(value) {
      if (!value) return "";
      return moment(value * 1000).fromNow();
    },
    pcs: function(value) {
      if (value == 1) return value + " pc";
      return value + " pcs";
    },
    shorting: function(value) {
      var length = 5;
      if (value.length > length) {
        value = value.substring(0, length) + "...";
      }
      return value;
    }
  }
};
</script>

<style scoped>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.canceled {
  background: #e62163;
}

.realized {
  background: #79c04d;
}
.hourglass_empty {
  color: #4dbac0;
}

.record-card {
  width: 100%;
  float: left;
  background: #2d3540;
  padding: 13px 15px 15px 15px;
  border-radius: 3px;
  margin-bottom: 1px;
  min-height: 68px;
  cursor: pointer;
  font-size: 12px;
}
.record-card:nth-child(odd) {
  background-color: #333b46;
}

.record-card:hover {
  background: #232a35;
}

.record-head {
  width: 100%;
  float: left;
  margin-right: -70px;
  padding-right: 65px;
}
.record-title {
  float: left;
}

.record-right {
  float: right;
}
.record-left {
  float: left;
  width: auto;
}

.record-body {
  color: white;
  width: auto;
  margin-left: 22px;
}

.record-menu {
  color: #808f9c;
}
.record-menu:hover {
  color: white;
}
</style>
